<template>
  <div class="vb-viewer">
    <vb-container
      ref="page"
      class="vb-page"
      :components="currentPage.components"
      :data="currentPage"
      :path="`${pageIndex}`"
      :edit="edit"
      :selectedPath="selectedPath"
      @scroll="scroll"
      @update="setHeightPage"
      @select="path => $emit('select', path)"
      @toDrag="path => $emit('drag', path)"
      @toDrop="path => $emit('drop', path)"
      @answer="payload => $emit('answer', payload)"
    />
    <div class="vb-control animation-right">
      <div class="vb-control-div vb-controll-div--hide">
        <button
          class="vb-control-btn"
          :disabled="currentHeight == minHeight"
          @click="scrollUp"
        >
          <div class="vb-control-btn-icon">
            <font-awesome-icon icon="arrow-up" />
          </div>
          <div class="vb-control-btn-text">
            RIDE UP
          </div>
        </button>
        <button
          class="vb-control-btn"
          :disabled="currentHeight == maxHeight"
          @click="scrollDown"
        >
          <div class="vb-control-btn-icon">
            <font-awesome-icon icon="arrow-down" />
          </div>
          <div class="vb-control-btn-text">
            RIDE DOWN
          </div>
        </button>
      </div>

      <div class="vb-control-div">
        <div class="vb-control-page">
          <button
            class="vb-control-page-btn"
            :disabled="pageNumber !== currentPage.page"
            @click="goToPage()"
          >
            <font-awesome-icon width="28" icon="search" />
          </button>
          <input
            class="vb-control-page-input"
            type="number"
            ref="page_number"
            :min="minPage"
            :max="maxPage"
            value="0"
          >
        </div>
      </div>

      <div class="vb-control-div">
        <button
          class="vb-control-btn"
          :disabled="pageIndex == (pages.length - 1)"
          @click="nextPage"
        >
          <div class="vb-control-btn-icon">
            <font-awesome-icon icon="arrow-right" />
          </div>
          <div class="vb-control-btn-text">
            NEXT PAGE
          </div>
        </button>

        <button
          class="vb-control-btn"
          :disabled="pageIndex == 0"
          @click="prevPage"
        >
          <div class="vb-control-btn-icon">
            <font-awesome-icon icon="arrow-left" />
          </div>
          <div class="vb-control-btn-text">
            PREVIOUS PAGE
          </div>
        </button>
      </div>

      <button
        class="vb-control-btn vb-control-btn-back"
        @click="() => !goBack ? undefined : goBack()"
      >
        BACK
      </button>
    </div>
  </div>
</template>
<script>
  import VBContainer from './VirtualBookContainer'

  export default {
    name: 'VBViewer',
    props: {
      pages: {
        required: true
      },
      goBack: {
        type: Function,
      },
      edit: {
        type: Boolean
      },
      selectedPath: {
        type: String
      }
    },
    data () {
      return {
        pageIndex: 0,
        pageNumber: 0,
        minPage: 0,
        maxPage: 0,
        currentHeight: 0,
        maxHeight: 0,
        minHeight: 0,
      }
    },
    computed: {
      currentPage () {
        if (!this.pages || !this.pages.length || !this.pages[this.pageIndex])
          return {
            page: this.pageNumber,
            type: 'container',
            components: []
          }

        return this.pages[this.pageIndex]
      }
    },
    components: {
      [VBContainer.name]: VBContainer,
    },
    methods: {
      setPagesData () {
        if (!this.pages.length) {
          this.pageIndex = 0
          this.$refs['page_number'].value = 0
          this.pageNumber = 0
          this.minPage = 0
          this.maxPage = 0
          return
        }

        this.pageNumber = this.pages[this.pageIndex].page
        this.minPage = this.pages[0].page
        this.maxPage = this.pages[this.pages.length - 1].page

        this.$refs['page_number'].value = this.pages[0].page
      },
      nextPage () {
        if (this.pageIndex < (this.pages.length - 1))
          ++this.pageIndex
      },
      prevPage () {
        if (this.pageIndex > 0)
          --this.pageIndex
      },
      getPage (page) {
        if (page > this.maxPage)
          page = this.maxPage
        else if (page < this.minPage)
          page = this.minPage

        let pageIndex = !this.pages.length ? 0 : this.pages.findIndex(p => p.page == page)

        if (pageIndex < 0)
          pageIndex = this.getPage(page + 1)

        return pageIndex
      },
      goToPage () {
        const pageIndex = this.getPage(this.$refs['page_number'].valueAsNumber)

        this.pageIndex = pageIndex
        this.pageNumber = this.currentPage.page

        this.$refs['page_number'].value = this.pageNumber
      },
      setHeightPage () {
        this.maxHeight = this.$refs['page'].$el.scrollHeight - this.$refs['page'].$el.offsetHeight
        this.minHeight = 0

        this.currentHeight = this.minHeight

        this.scrollPage()
      },
      scroll (event) {
        this.currentHeight = event.target.scrollTop
      },
      scrollUp () {
        this.currentHeight -= 100

        if (this.currentHeight < this.minHeight)
          this.currentHeight = this.minHeight

        this.scrollPage()
      },
      scrollDown () {
        this.currentHeight += 100

        if (this.currentHeight > this.maxHeight)
          this.currentHeight = this.maxHeight

        this.scrollPage()
      },
      scrollPage () {
        this.$refs['page'].$el.scrollTop = this.currentHeight
      },
    },
    watch: {
      pages () {
        this.setPagesData()
      },
      pageIndex (val, oldVal) {
        if (val == oldVal)
          return

        this.pageNumber = this.currentPage.page

        this.$refs['page_number'].value = this.pageNumber

        this.$emit('change')
      },
      currentPage () {
        this.$nextTick(() => {
          this.setHeightPage()
        })
      },
    },
    mounted () {
      this.setPagesData()

      this.$nextTick(() => {
        this.setHeightPage()
      })
    }
  }
</script>
<style lang="scss" scoped>
  .vb-viewer {
    display: flex;
    width: 100%;
    height: 100%;
    max-width: 1050px;
    padding: 20px;
  }

  .vb-page {
    overflow-y: auto;
    max-height: 540px;
  }

  .vb-control {
    border: 1px solid #9ebbda;
    border-radius: 30px;
    background: #cce3fb;
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    margin: 0 0 0 .5rem;

    .vb-control-div {
      display: flex;
      flex-direction: column;
      width: 100%;

      &:not(:last-child) {
        padding-bottom: 1rem;
      }

      & > .vb-control-btn:last-child {
        margin-top: 1rem;
      }
    }

    button.vb-control-btn {
      display: flex;
      justify-content: left;
      align-items: center;
      text-align: center;
      line-height: 30px;
      width: 190px;
      font-size: 12px;
      background: #98b2ce;
      border: 1px solid #a1b9d3;
      border-radius: 25px;
      padding: 10px;
      color: #416182;
      font-weight: 300;
      font-family:'volte', Arial, Helvetica, sans-serif;

      &.vb-control-btn-back {
        justify-content: center;
        background: #ffffff;
        color: #416182;
        margin-top: 4rem !important;
      }

      .vb-control-btn-icon {
        margin-right: 1.5rem;
        background: #fff;
        color: #98b2ce;
        padding: 0px 10px;
        border-radius: 25px;
      }

      &:disabled  {
        background: #b4c7dc;
        color: #89a4c2;

        .vb-control-btn-icon {
          background: #89a4c2;
          color: #b4c7dc;
        }
      }
    }

    .vb-control-page {
      display: flex;
      width: 190px;
      font-size: 12px;
      border: 1px solid #a1b9d3;
      border-radius: 25px;
      background: #fff;

      button.vb-control-page-btn {
        padding: 10px 20px;
        border-radius: 25px;
        background: #98b2ce;
        border: 0;
        border-right: 1px solid #a1b9d3;
        color: #446384;
        font-weight: 300;
        font-size: 20px;
        font-family:'volte', Arial, Helvetica, sans-serif;
      }

      input.vb-control-page-input {
        font-family:'volte', Arial, Helvetica, sans-serif;
        font-weight: 700;
        font-size: 24px;
        color: #98b2ce;
        text-align: center;
        border-radius: 25px;
        width: 92px;
        border: 0;
        padding-right: 1rem;

        &:focus {
          outline: none;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .vb-viewer{
      flex-direction: column-reverse;
    }
    .vb-control {
      margin: 0 0 20px 0;
      
      .vb-control-div {
        flex-direction: row;
        justify-content: space-between;

        &:last-of-type {
          flex-direction: row-reverse;
        }
        
        & > .vb-control-btn:last-child {
          margin-top: 0;
        }

        & > .vb-control-page {
          flex: 1;
        }
      }
    }  
 }

@media (max-width: 560px) {
  .vb-control-div {
    &.vb-controll-div--hide {
      display: none;
      padding-bottom: 0;
    }

    .vb-control-btn {
      width: auto !important;

      &-icon {
        margin: 0 !important;
      }
      
      &-text {
        display: none;
      }
    }

    &:last-of-type {
      padding-bottom: 0 !important;
    }
  }

  .vb-control-btn-back {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VirtualBookViewer/index.vue